import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

export const WON_STAGE = "Won / Advertiser";

function WonMatchDialog({ st, close }) {
  const choose = (extra) => { const p = st.proceed; close(); p(extra); };
  return (
    <Dialog open={!!st} onOpenChange={(o) => !o && close()}>
      <DialogContent data-testid="won-match-dialog">
        <DialogHeader><DialogTitle className="font-display">Is this an existing company?</DialogTitle>
          <DialogDescription>Similar advertiser records were found for {st?.lead.business_name}. Link to one to avoid a duplicate company.</DialogDescription></DialogHeader>
        <div className="space-y-2">
          {st?.matches.map((m) => (
            <div key={m.id} className="flex items-center justify-between gap-2 rounded-lg border border-slate-200 p-3" data-testid={`won-match-${m.id}`}>
              <div className="min-w-0"><p className="font-semibold text-sm">{m.name}</p>
                <p className="text-xs text-slate-400 truncate">{[m.email, m.phone, m.website, m.territory, m.lifecycle].filter(Boolean).join(" · ")}</p></div>
              <Button size="sm" onClick={() => choose({ business_id: m.id })} data-testid={`won-link-${m.id}`}>Same company</Button>
            </div>
          ))}
        </div>
        <DialogFooter><Button variant="outline" onClick={close}>Cancel</Button>
          <Button variant="outline" onClick={() => choose({ won_new_business: true })} data-testid="won-new-company">No — create new company</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function useWonFlow() {
  const [st, setSt] = useState(null);
  const run = async (lead, proceed) => {
    if (lead.business_id) return proceed({});
    try {
      const { data } = await api.get("/businesses-match", { params: { name: lead.business_name || "", email: lead.email || "", phone: lead.phone || "", website: lead.website || "" } });
      if (data.matches.length) return setSt({ lead, matches: data.matches, proceed });
    } catch { /* matching is advisory */ }
    return proceed({});
  };
  return [run, <WonMatchDialog st={st} close={() => setSt(null)} />];
}
